import api from "./api";
import BaseService from "./base.service";

export default class EbooksService extends BaseService {
    constructor(page?: number | string) {
        if (page) {
            super(`multimidia/ebooks?page=${page}`);
        } else {
            super("multimidia/ebooks");
        }
    }

    async getDetails(id: number) {
        try {
            const response = await api.get(`multimidia/ebooks/${id}/`);
            return response.data;
        } catch (err) {
            console.error(`erro ao buscar detalhes do ebook ${id} :`, err);
            return { success: false };
        }
    }

    async mark_as_seen(id: number) {
        try {
            const response = await api.get(`${this.resource}/${id}/baixar/`);
            return response.data;
        } catch (err) {
            console.error(`erro ao marcar ebook como visto ${this.resource} :`, err);
            return { success: false };
        }
    }
}
